export default "__VITE_ASSET__B_WX$AX1__"